module.exports = {
  env: 'preview',
  domain: ['pfizeruat.tsepcn.com'],
  aegisId: 'akNqIsanJXJnMpAhyv',
  reportDomain: 'baike.sparta.html5.qq.com',
  cosAppId: '1304685099',
  bucket: 'tsep-prod-1304685099',
  region: 'ap-guangzhou',
};
